// @flow
import $ from 'jquery';

/**
 * Odscrollování na kotvu nebo jQuery element
 */
export default (): void => {

  window.scrollToAnchor = function (element, customOffset) {
  	let targetOffset = parseInt(customOffset) || 0;
    //let navToggle = $("button.navbar-toggle");
  	// pokud existuje pevná horní lišta, započte do scrollu i její výšku
  	if ($('nav.navbar').height() > 0 ) {
  		targetOffset += parseInt($(element).offset().top - ($('nav.navbar').outerHeight()));
  	} else {
  		targetOffset += parseInt($(element).offset().top);
  	}
  	// pokud je otevřené menu zavřeme jej
    /*if(!navToggle.hasClass('collapsed')) {
      navToggle.trigger('click');
    }*/
  	$('html,body').animate({scrollTop:targetOffset}, 1800);
  };
  // animace scrollu na hash
  $('html').on("click", ".js_scroll", function (e) {
    e.preventDefault();
   	scrollToAnchor($(this.hash));
  });
  $('html').on("click", ".header-with-anchors__scroll", function (e) {
    e.preventDefault();
   	scrollToAnchor($(this.hash));
  });

};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/menuScroll.js